function searchBarClose() {
  const closeBtn = document.querySelector(
    '.search__button.icon-mr-close-dark-btn',
  );
  const searchInput = document.querySelector('.product-grid__search-input');

  if (closeBtn && searchInput) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      searchInput.value = '';
      closeBtn.disabled = true;
      closeBtn.click();
      closeBtn.disabled = false;
    });
  }
}

export { searchBarClose as default };
